"use client";

import { c as _c } from "react/compiler-runtime";
import { Button } from "@/components/rac/button";
import { Input } from "@/components/rac/input";
import { isValidEmail } from "@/utils/verification";
import { Loader } from "lucide-react";
import React from "react";
import { Label } from "react-aria-components";
import { OtpInput } from "../login-dialog/otp-input";
import { type EmailVerificationStep } from "./index";
export const isValidOtp = (otp: string): boolean => {
  return /^\d{5}$/.test(otp);
};
interface ShortEmailVerificationProps {
  step: EmailVerificationStep;
  email: string;
  setEmail: (email: string) => void;
  otp: string;
  setOtp: (otp: string) => void;
  error: string;
  isLoading: boolean;
  handleSendOTP: () => void;
  handleVerifyOTP: () => void;
  handleBackToEmail: () => void;
  handleResendOTP: () => void;
  resendTimer: number;
  canResend: boolean;
  handleKeyPress: (event: React.KeyboardEvent) => void;
  required?: boolean;
}
export function ShortEmailVerification(t0) {
  const $ = _c(20);
  const {
    step,
    email,
    setEmail,
    otp,
    setOtp,
    error,
    isLoading,
    handleSendOTP,
    handleVerifyOTP,
    handleBackToEmail,
    handleResendOTP,
    resendTimer,
    canResend,
    handleKeyPress,
    required: t1
  } = t0;
  const required = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== canResend || $[1] !== email || $[2] !== handleBackToEmail || $[3] !== handleResendOTP || $[4] !== handleSendOTP || $[5] !== handleVerifyOTP || $[6] !== isLoading || $[7] !== otp || $[8] !== required || $[9] !== resendTimer || $[10] !== setEmail || $[11] !== setOtp || $[12] !== step) {
    t2 = ["email", "verified"].includes(step) ? <><div className="space-y-3"><div><Label className="text-sm font-medium text-gray-700">Email Address</Label><Input required={required} type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="Enter your email" className="w-full mt-1" disabled={isLoading || step === "verified"} autoComplete="email" /></div>{isValidEmail(email) && <>{step === "email" && <div className="flex justify-end"><Button className="px-3 py-1.5 h-8 text-xs font-medium" onPress={handleSendOTP} isDisabled={isLoading || !email} variant="default">{isLoading ? "Sending..." : "Send OTP"}</Button></div>}{step === "verified" && <div className="flex justify-end"><svg className="w-4 h-4 text-green-600" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" stroke="currentColor"><path d="M5 13l4 4L19 7" /></svg><span className="text-xs text-green-600 font-medium ml-1">Verified</span></div>}</>}</div></> : <><div className="space-y-3"><OtpInput otp={otp} onOtpChange={setOtp} onEnterPress={handleVerifyOTP} isDisabled={isLoading} label="Email Verification" placeholder="Enter code" /><div className="flex items-center justify-between space-x-2"><Button variant="link" className="px-1 py-0.5 h-6 text-xs" onPress={handleBackToEmail} isDisabled={isLoading}>Back</Button>{canResend ? <Button variant="outline" className="px-2 py-0.5 h-6 text-xs border-gray-300" onPress={handleResendOTP} isDisabled={isLoading}>{isLoading ? <Loader className="w-3 h-3 animate-spin" /> : "Resend"}</Button> : <span className="text-xs text-gray-500">{resendTimer}s</span>}<Button className="px-2 py-0.5 h-6 text-xs" onPress={handleVerifyOTP} isDisabled={isLoading || !otp} variant="default">{isLoading ? <Loader className="w-3 h-3 animate-spin" /> : "Verify"}</Button></div></div></>;
    $[0] = canResend;
    $[1] = email;
    $[2] = handleBackToEmail;
    $[3] = handleResendOTP;
    $[4] = handleSendOTP;
    $[5] = handleVerifyOTP;
    $[6] = isLoading;
    $[7] = otp;
    $[8] = required;
    $[9] = resendTimer;
    $[10] = setEmail;
    $[11] = setOtp;
    $[12] = step;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  let t3;
  if ($[14] !== error) {
    t3 = error && <p className="mt-2 text-xs text-red-600 text-center">{error}</p>;
    $[14] = error;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  let t4;
  if ($[16] !== handleKeyPress || $[17] !== t2 || $[18] !== t3) {
    t4 = <div onKeyDown={handleKeyPress}>{t2}{t3}</div>;
    $[16] = handleKeyPress;
    $[17] = t2;
    $[18] = t3;
    $[19] = t4;
  } else {
    t4 = $[19];
  }
  return t4;
}